import { render, staticRenderFns } from "./ConsumeGoodsClass.vue?vue&type=template&id=70a8ab7a&scoped=true&"
import script from "./ConsumeGoodsClass.vue?vue&type=script&lang=js&"
export * from "./ConsumeGoodsClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a8ab7a",
  null
  
)

export default component.exports